/**
 * Resolves the `ids` variable for the EmployeeSelectorV2 GraphQL query.
 *
 * By default, `forcedEmployeeIds` are treated as a strict allowlist and
 * returned unchanged.
 *
 * When `showAccessStatusFilter` is true AND a user-selected
 * accessStatus filter is active (not forced), the forced employeeIds are
 * dropped. This avoids an empty intersection: forced IDs typically only
 * contain active employees, so intersecting them with non-active statuses
 * (e.g. "revoked") yields nothing.
 *
 * When forcedFilters include their own accessStatus (e.g., PendingModal
 * passes accessStatus: ['invited'] alongside matching employeeIds), the
 * IDs are always kept because they are already aligned with the forced status.
 */
export function resolveEmployeeIds({
  accessStatus,
  forcedAccessStatus,
  forcedEmployeeIds,
  showAccessStatusFilter = false,
}: {
  accessStatus: string[] | undefined
  forcedAccessStatus: string[] | undefined
  forcedEmployeeIds: string[] | undefined
  showAccessStatusFilter?: boolean
}): string[] | undefined {
  if (showAccessStatusFilter && accessStatus?.length && !forcedAccessStatus?.length) {
    return undefined
  }
  return forcedEmployeeIds
}
